import axios from "axios";
import env from "../../../env";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Promise } from "es6-promise";
NProgress.configure({
  easing: "ease",
  speed: 100,
  showSpinner: false,
});

// Dev tunnel services (ngrok, localtunnel, Cloudflare Tunnel...) hand out
// random subdomain.host.tld addresses for local testing — same shape as a
// real subdomain.company.com tenant URL, so without this list every one of
// them gets misread as a tenant name (e.g. "teaching-elf-skilled" from
// teaching-elf-skilled.ngrok-free.app), silently breaking every tenant-scoped
// request (login, profile fetch...) for whoever is testing through a tunnel.
const DEV_TUNNEL_SUFFIXES = [
  ".ngrok-free.app",
  ".ngrok.app",
  ".ngrok.io",
  ".loca.lt",
  ".trycloudflare.com",
];

// Extract tenantId from subdomain
const getTenantId = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return null;
  }

  if (DEV_TUNNEL_SUFFIXES.some((suffix) => hostname.endsWith(suffix))) {
    return null;
  }

  if (parts.length === 2 && parts[1] === "localhost") {
    return parts[0];
  }

  if (parts.length > 2) {
    return parts[0];
  }

  return null;
};

// create a new axios instance
const instance = axios.create();

// before a request is made start the nprogress
instance.interceptors.request.use(
  (config) => {
    NProgress.start();

    if (getTenantId() !== "demo-ns-hr" && getTenantId() !== null) {
      // Add tenantId header
      config.headers["tenantId"] = getTenantId();
    }

    // Add Authorization header if token exists
    const T = localStorage.getItem("Nannotoken");
    if (T) {
      const token = atob(T);
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

// before a response is returned stop nprogress
instance.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

export default instance;
